<template>
  <div class="container container-row padded">
    <wrap-container class="relative-container cascade w50 consult-left">
      <wrap-container>
        <h1
          id="titulo"
          class="titulo p32 medium oscuro"
          v-safe-html="config.pasos.consulta.titulo"
        >
          {{ config.pasos.consulta.titulo }}
        </h1>
        <h2
          id="subtitulo"
          class="titulo oscuro"
          v-safe-html="config.pasos.consulta.subtitulo"
        >
          {{ config.pasos.consulta.subtitulo }}
        </h2>
      </wrap-container>
      <form-validator>
        <wrap-container class="grid-container grid-container--6-6">
          <text-input
            class="col1"
            label="Nombres según documento"
            hint="Ingresá tus nombres"
            name="nombre"
            v-model="model.nombre"
            :maxlengthError="20"
            :required="true"
            pattern="(^[A-Za-z ']{1,20})$"
            @click="trackClick('nombre')"
            @onFocus="trackClick('nombre')"
            analyticsName="nombre"
            :analyticsTypology="config.analyticsTypology"
            quantumObfuscate
          />
          <text-input
            class="col2"
            label="Apellidos según documento"
            hint="Ingresá tus apellidos"
            name="apellido"
            v-model="model.apellido"
            :maxlengthError="55"
            :required="true"
            pattern="(^[A-Za-z ']{1,55})$"
            @click="trackClick('apellido')"
            @onFocus="trackClick('apellido')"
            analyticsName="apellido"
            :analyticsTypology="config.analyticsTypology"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container class="grid-container grid-container--6-6">
          <dni-input
            class="col1"
            label="Número de documento"
            hint="Ej: 28956372"
            v-model="model.numeroDoc"
            :required="true"
            maxlength="8"
            @click="trackClick('dni')"
            @onFocus="trackClick('dni')"
            inputName="numeroDoc"
            :tipoDoc.sync="model.tipoDoc"
            analyticsName="número de documento"
            quantumObfuscate
          />
          <sexo-select
            class="col2"
            name="sexo"
            :required="true"
            v-model="model.sexo"
            @click="trackClick('sexo')"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container v-show="model.tipoDoc === tiposDocumentos.DNE">
          <section-label value="Indicanos tu tipo de residencia:" />
          <residence-type
            v-model="model.tipoResidencia"
            name="tipoResidencia"
            :required="model.tipoDoc === tiposDocumentos.DNE"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container
          class="double-width grid-container--6-6"
          v-show="model.tipoDoc === tiposDocumentos.DNE"
        >
          <country-selector
            :esExtranjero="model.tipoDoc === tiposDocumentos.DNE"
            class="col1"
            v-model="model.nacionalidad"
            name="nacionalidad"
            @click="trackClick('nacionalidad')"
            @onFocus="trackClick('nacionalidad')"
            quantumObfuscate
          />
        </wrap-container>

        <wrap-container>
          <wrap-container class="grid-container grid-container--6-6">
            <email-field
              class="col1 email-date"
              v-model="model.email"
              name="email"
              :required="true"
              @click="trackClick('email')"
              @onFocus="trackClick('email')"
              analyticsName="email"
              :analyticsTypology="config.analyticsTypology"
              quantumObfuscate
            />
            <date-field
              class="col2 email-date"
              v-model="model.fechaNacimiento"
              subhint="Ejemplo: 18/07/1985"
              name="fechaNacimiento"
              :required="true"
              :minAge="14"
              :maxAge="100"
              @click="trackClick('fechaNacimiento')"
              @onFocus="trackClick('fechaNacimiento')"
              :compatible="validarNumeroDocFechaNacimiento"
              :debeSerMayor="true"
              analyticsName="fecha de nacimiento"
              quantumObfuscate
            />
          </wrap-container>
        </wrap-container>
        <wrap-container class="grid-container grid-container--6-6">
          <phone-number
            class="col1"
            v-model="model.celular"
            :required="true"
            name="celular"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container>
          <div class="terms-wrapper container">
            <p>
              Al continuar acepto
              <custom-link
                class="custom-link"
                label="términos y condiciones"
                analyticsName="terminos y condiciones"
                @click.native="showTerms()"
              />
              sobre el tratamiento de datos.
            </p>
          </div>
        </wrap-container>
        <wrap-container v-if="!isProduction"></wrap-container>
        <sales-button
          ref="salesbutton"
          id="conocerOferta"
          @click="probar"
          label="Conocer oferta"
          analyticsName="conocer oferta"
          color="#1464A5"
        />
      </form-validator>
    </wrap-container>
    <wrap-container
      class="relative-container cascade w50 padding-17-left-right consult-right"
    >
      <img
        class="img-consulta"
        src="../assets/img/ofertaNomina/group-372.png"
        alt="Abrir cuenta BBVA"
      />
    </wrap-container>
    <wrap-container class="recaptcha-holder w50" style="text-align: center">
      <vue-recaptcha
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        @render="onCaptchaRendered"
        size="invisible"
        badge="inline"
        sitekey="6Lfp-yUUAAAAAFcXnw7yb4EhrGGz0zmF3SZhqViW"
      >
      </vue-recaptcha>
    </wrap-container>
  </div>
</template>

<script>
import { tiposDocumentos } from "@/config/constants";
import WrapContainer from "@/components/core/Container";
import CountrySelector from "@/components/core/composite/combos/CountrySelector";
import FormValidator from "@/components/core/FormValidator";
import TextInput from "@/components/core/TextInput";
import VueRecaptcha from "vue-recaptcha";
import EmailField from "@/components/core/EmailField";
import DateField from "@/components/core/DateField";
import CustomLink from "@/components/core/CustomLink";
import SalesButton from "@/components/core/SalesButton";
import DniInput from "@/components/core/composite/DniInput";
import SectionLabel from "@/components/core/SectionLabel";
import ResidenceType from "@/components/core/custom/ResidenceType";
import PhoneNumber from "@/components/core/composite/PhoneNumber";
import SexoSelect from "@/components/core/custom/SexoSelect.vue";
import { RECHAZADO } from "@/config/constants/step-constants";
import consultaBaseMixin from "@/mixins/consulta-base";

export default {
  name: "Consulta",
  mixins: [consultaBaseMixin],
  methods: {
    probar() {
      if (
        this.model.tipoResidencia === "temporal" &&
        this.model.tipoDoc == tiposDocumentos.DNE
      ) {
        this.$router.push({ name: "mensaje", params: { mje: RECHAZADO } });
        return;
      }

      this.$refs.recaptcha.execute();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    showTerms() {
      /** Se dejan de mostrar los terminos y condiciones en un modal
       * con un archivo pdf, para mostrar los TYC del footer
       */
      document
        .getElementsByTagName("footer")[0]
        .scrollIntoView({ behavior: "smooth" });
    }
  },
  components: {
    TextInput,
    EmailField,
    FormValidator,
    WrapContainer,
    DateField,
    CustomLink,
    SalesButton,
    DniInput,
    SectionLabel,
    ResidenceType,
    PhoneNumber,
    VueRecaptcha,
    CountrySelector,
    SexoSelect
  }
};
</script>
<style scoped>
.container-row {
  max-width: 1200px;
  margin: 0 auto;
}

.img-consulta {
  margin-top: 160px;
  width: 70%;
}

.terms-wrapper p {
  font-weight: 600;
  color: #555;
  line-height: 2px;
  font-size: 15px;
  margin-top: 20px;
}

.terms-wrapper div p {
  color: #1464a5;
}

div.recaptcha-holder {
  margin-top: 24px;
  opacity: 0.3;
}

#subtitulo {
  font-size: 15px;
  line-height: 24px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-weight: 600;
  color: #555;
  margin-bottom: 40px;
}

#titulo {
  font-size: 26px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 16px;
}

.double-width {
  margin-bottom: 32px;
}

.genero-sub {
  margin-top: -10px;
  margin-bottom: 25px;
}

#app.consulta
  > div.router-container
  > div.wrap-container.router-container-inner
  > div
  > div.wrap-container.relative-container.cascade.w50.consult-left
  > form
  > div:nth-child(5)
  > div {
  margin-bottom: 0px !important;
}

@media screen and (max-width: 1024px) {
  .consult-right {
    display: none;
  }

  .consult-left {
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
  }

  .img-consulta {
    display: none;
  }
}

@media screen and (max-width: 624px) {
  #titulo {
    font-size: 22px;
  }

  .grid-container {
    margin-bottom: 24px;
  }

  .terms-wrapper p {
    line-height: 2px;
    font-size: 14px;
    margin-bottom: 20px;
  }

  div.recaptcha-holder {
    display: flex;
    justify-content: center;
  }
}
</style>
